import React from "react";
import $ from "jquery"
import { _popup_config } from "../../data/modal_popup_info"
import DisplayData from "./DisplayData"
import DisplayDataSelector from "./DisplayDataSelector"
import NavigationButtonsList from "./NavigationButtonsList"
import close_img from "../../assets/images/close_btn.svg"
import {callAnalyticsAPI,callAnalyticsAPIOther} from "../../api/user"



class PopModalComponent extends React.Component{

    constructor(props) {
        super(props)
        this.state = {

            infoSpotType : null,
            info_view_active : '',
            default_view_active : 'active',
            modalContentInfo : null,
            navigationContent : null,
            navActive : '',
            previouspopupModalContentObj : null,
            popupConfig : null,
            displayDataShow : false ,
            displayDataSelectorShow : false,
            navigationButtonsShow : false,
            selectorArray : null,
            buttonListArray : null,
            navigationLevel : null,
            selectedContentComponents : null,
            btn_inline : "",
            modalInfoObjSelected : null,
            videoPausedStatus : false,
            selMenu : props.selMenu,
            videStarted : false,
            videoPlayedSeconds: 0,
            videoTotalDuration : 0,
        }

    }


    UNSAFE_componentWillReceiveProps(nextProps) {


        if(this.state.infoSpotType !== nextProps.popupModalContentObj && nextProps.show) {
            

            let buttonclass = ""
            if(nextProps.popupModalContentObj === "fiberglass_full_advantage") {
                buttonclass = "button_inline"
            }

            const infoSpotDisplayJsonData = _popup_config.find(item => item.ref === nextProps.popupModalContentObj);


            if(infoSpotDisplayJsonData.navigationLevel === -1) {

                this.setState({
                    modalInfoObjSelected : infoSpotDisplayJsonData,
                    modalContentInfo : infoSpotDisplayJsonData,
                    displayDataShow : true,
                    btn_inline : buttonclass,
                    navigationButtonsShow : false,
                    infoSpotType : nextProps.popupModalContentObj
                })

            }

            if(infoSpotDisplayJsonData.navigationLevel === 0 || infoSpotDisplayJsonData.navigationLevel === 3) {

                if(infoSpotDisplayJsonData.ref === "veris_collection"){


                    if(!sessionStorage.getItem("veris_collection_started_time")){

                        let starttime = new Date();
                        starttime = Date.parse(starttime);
                        sessionStorage.setItem("veris_collection_started_time",starttime)
                        //alert("started")
                    }
                    

                }

                if(infoSpotDisplayJsonData.ref === "fiberglass_steel_entry_doors"){

                    if(!sessionStorage.getItem("fiberglass_collection_started_time")){

                        let starttime = new Date();
                        starttime = Date.parse(starttime);
                        sessionStorage.setItem("fiberglass_collection_started_time",starttime)

                        //alert("started")
                    }
    
                }

                this.setState({
                    modalInfoObjSelected : infoSpotDisplayJsonData,
                    selectedContentComponents : infoSpotDisplayJsonData.ContentComponents,
                    modalContentInfo : infoSpotDisplayJsonData.ContentComponents[0],
                    displayDataShow : true,
                    displayDataSelectorShow : true,
                    selectorArray : infoSpotDisplayJsonData.navigationComponents,
                    navigationLevel : infoSpotDisplayJsonData.navigationLevel,
                    buttonListArray : infoSpotDisplayJsonData.ContentComponents[0].buttonList,
                    btn_inline : buttonclass,
                   infoSpotType : nextProps.popupModalContentObj


                })
            }

            if(infoSpotDisplayJsonData.navigationLevel === 2) {

                this.setState({
                    modalInfoObjSelected : infoSpotDisplayJsonData,
                    selectedContentComponents : infoSpotDisplayJsonData.ContentComponents,
                    modalContentInfo : infoSpotDisplayJsonData.ContentComponents[0],
                    displayDataShow : false,
                    displayDataSelectorShow : false,
                    selectorArray : infoSpotDisplayJsonData.navigationComponents,
                    buttonListArray : infoSpotDisplayJsonData.ContentComponents[0].buttonList,
                    navigationButtonsShow  :true,
                    btn_inline : buttonclass,
                   infoSpotType : nextProps.popupModalContentObj


                })
            }

            $("#myModal").modal({keyboard: false}, 'show');

            


        }

    }

    handleVideoStatus = (stat) => {

        this.setState({ videStarted : stat })

    }

    handleupdateVideoPlayingTime = (e) => {
        this.setState({
            videoPlayedSeconds : e.seconds,
            videoTotalDuration : e.duration,
        })
    }

    endTime = (startTime) => {

        startTime = parseFloat(startTime);
        let endTime = new Date();
        endTime = Date.parse(endTime);
        let timeDiff = endTime - startTime; //in ms
        timeDiff /= 1000;
        let seconds = Math.round(timeDiff);
        return seconds
    }
    
    componentDidMount (){

        let that = this
        $('#myModal').on('hide.bs.modal', function (e) {


            if(that.state.videStarted) {
                const reqData = {}
                let user_id = sessionStorage.getItem("user_id");
                if(user_id) {
                    reqData.user_id = user_id;
                    reqData.area_id = that.state.modalInfoObjSelected.ref;
                    reqData.resource_id = that.state.modalContentInfo.navigation_ref
                    reqData.resource_type = "video";
                    reqData.prev_area = 0;
                    reqData.spent_time = that.state.videoPlayedSeconds;
                    reqData.total_time = that.state.videoTotalDuration;
                    reqData.video_status = "Ended";
                    reqData.download = 0;
                    reqData.guided_mode = 0;
                    callAnalyticsAPI(reqData)
                    that.handleVideoStatus(false)
                }

            }


            
            //Send api for vetris and fiberglass time spend if avaialble
            that.sendTimeSpendNewProducts()



            //Area Anylytics api
            if(that.state.modalInfoObjSelected.ref === "rotation_keysuccess" ) {
                const reqData = {}
                let user_id = sessionStorage.getItem("user_id");
                reqData.user_id = user_id;
                reqData.area_id = "thermatru_key_success";
                reqData.resource_id = "thermatru_key_success";
                reqData.resource_type = "area";
                reqData.prev_area = "thermatru_key_success";
                reqData.spent_time = 0;
                reqData.total_time = 0;
                reqData.video_status = "";
                reqData.download = 0;
                reqData.guided_mode = 0;
                let strttime = sessionStorage.getItem("started_time")
                if(strttime){
                    reqData.spent_time = that.endTime(strttime)
                }
                callAnalyticsAPIOther(reqData)
                sessionStorage.removeItem("started_time")

            }

            
            if(that.state.modalInfoObjSelected.ref === "tools_explore_more" ) {
                const reqData = {}
                let user_id = sessionStorage.getItem("user_id");
                reqData.user_id = user_id;
                reqData.area_id = "thermatru_tools_support";
                reqData.resource_id = "thermatru_tools_support";
                reqData.resource_type = "area";
                reqData.prev_area = "thermatru_tools_support";
                reqData.spent_time = 0;
                reqData.total_time = 0;
                reqData.video_status = "";
                reqData.download = 0;
                reqData.guided_mode = 0;
                let strttime = sessionStorage.getItem("started_time")

                if(strttime){
                    reqData.spent_time = that.endTime(strttime)
                }

                callAnalyticsAPIOther(reqData)
                sessionStorage.removeItem("started_time")

            }


            if(that.state.modalInfoObjSelected.ref === "expert_guidance" ) {
                const reqData = {}
                let user_id = sessionStorage.getItem("user_id");
                reqData.user_id = user_id;
                reqData.area_id = "citp";
                reqData.resource_id = "citp";
                reqData.resource_type = "area";
                reqData.prev_area = "citp";
                reqData.spent_time = 0;
                reqData.total_time = 0;
                reqData.video_status = "";
                reqData.download = 0;
                reqData.guided_mode = 0;
                let strttime = sessionStorage.getItem("started_time")
                if(strttime){
                    reqData.spent_time = that.endTime(strttime)
                }

                callAnalyticsAPIOther(reqData)
                sessionStorage.removeItem("started_time")

            }
            
           // alert(that.state.modalInfoObjSelected.ref)
            if(that.state.modalInfoObjSelected.ref === "fypon_explore_more_tools") {
                const reqData = {}
                let user_id = sessionStorage.getItem("user_id");
                reqData.user_id = user_id;
                reqData.area_id = "tools_support_fypon";
                reqData.resource_id = "tools_support_fypon";
                reqData.resource_type = "area";
                reqData.prev_area = "tools_support_fypon";
                reqData.spent_time = 0;
                reqData.total_time = 0;
                reqData.video_status = "";
                reqData.download = 0;
                reqData.guided_mode = 0;

                let strttime = sessionStorage.getItem("started_time")
                if(strttime){
                    reqData.spent_time = that.endTime(strttime)
                }
                callAnalyticsAPIOther(reqData)
                sessionStorage.removeItem("started_time")

            }

            if(that.state.modalInfoObjSelected.ref === "2023_trends") {
                const reqData = {}
                let user_id = sessionStorage.getItem("user_id");
                reqData.user_id = user_id;
                reqData.area_id = "Trends & New Products";
                reqData.resource_id = "2023_trends";
                reqData.resource_type = "section";
                reqData.prev_area = 0;
                reqData.spent_time = 0;
                reqData.total_time = 0;
                reqData.video_status = "";
                reqData.download = 0;
                reqData.guided_mode = 0;

                let strttime = sessionStorage.getItem("started_time")
                if(strttime){
                    reqData.spent_time = that.endTime(strttime)
                }
                callAnalyticsAPIOther(reqData)
                sessionStorage.removeItem("started_time")

            }



            

          
            that.setState({
                modalContentInfo : null,
                displayDataShow : false,
                displayDataSelectorShow : false,
                selectorArray : null,
                navigationLevel : null,
                buttonListArray : null,
                navigationButtonsShow : false,
                infoSpotType : null
            })
            that.props.changeModalShowStatusFals()
            $(".modalVisibleUiHide").show();

        }) 

        $(".full_screen_div").hide()


    }


    sendTimeSpendNewProducts = () => {
        //veris collection and fiberglass time spend calculating
        let veris_started_check = sessionStorage.getItem("veris_collection_started_time")
        let fiberglass_started_check = sessionStorage.getItem("fiberglass_collection_started_time")


        if(veris_started_check){

            const reqData = {}
            let user_id = sessionStorage.getItem("user_id");
            reqData.user_id = user_id;
            reqData.area_id = "Trends & New Products";
            reqData.resource_id = "veris_collection";
            reqData.resource_type = "section";
            reqData.prev_area = 0;
            reqData.spent_time = 0;
            reqData.total_time = 0;
            reqData.video_status = "";
            reqData.download = 0;
            reqData.guided_mode = 0;

            reqData.spent_time = this.endTime(veris_started_check)
            callAnalyticsAPIOther(reqData)
            sessionStorage.removeItem("veris_collection_started_time")

        }


        if(fiberglass_started_check){


            const reqData = {}
            let user_id = sessionStorage.getItem("user_id");
            reqData.user_id = user_id;
            reqData.area_id = "Trends & New Products";
            reqData.resource_id = "fiberglass_steel_entry_doors";
            reqData.resource_type = "section";
            reqData.prev_area = 0;
            reqData.spent_time = 0;
            reqData.total_time = 0;
            reqData.video_status = "";
            reqData.download = 0;
            reqData.guided_mode = 0;

            reqData.spent_time = this.endTime(fiberglass_started_check)
            callAnalyticsAPIOther(reqData)
            sessionStorage.removeItem("fiberglass_collection_started_time")

        }
        

    }

    handleModalClose = () => {

        if(this.state.modalInfoObjSelected.parent){

            if(this.state.modalInfoObjSelected.parent === "new_products"){

                this.sendTimeSpendNewProducts()

            }

            
            this.props.changeModalContent(this.state.modalInfoObjSelected.parent)  
            return;
        }
        
        $('#myModal').modal('hide');

    }

    setModalContentInfo = () =>{


        const popup_config = _popup_config.find(item => item.ref === this.props.popupModalContentObj);

        this.setState({
            popupConfig : popup_config,
            modalContentInfo : popup_config.ContentComponents[0],
            navigationContent : popup_config.navigationComponents
        })

    }

    changeContent = (val) => {


        if(val.redirect) {

            window.open(val.redirect, '_blank');
            return;
        }

        const filterComponent = this.state.popupConfig.ContentComponents.find(item => item.navigation_ref === val.key);
        if(this.state.modalContentInfo.childType === "navigation") {
            filterComponent.type = "navigation_box"
        }

        this.setState({
            modalContentInfo : filterComponent,
        })
      
    }

    changeDisplayToButtonList = () => {

        this.setState({
            displayDataShow : false,
            displayDataSelectorShow : false,
            navigationButtonsShow : true
        })
    }

    setDisplayOnlyView = (data) => {

        if(this.state.navigationLevel !== 3) {

            this.setState({
                modalContentInfo : data,
                displayDataShow : true,
                navigationButtonsShow : false
            })
        }
        else {

            this.setState({
                modalContentInfo : data,
                displayDataShow : true,
                displayDataSelectorShow : false,
                navigationButtonsShow : false
            })

        }




    }

    handleVideoPlayStatus= (status) => {
        this.setState({
            videoPausedStatus : status,
        })
    }
    loadingStatus = (status) => {
        this.props.changeLoaderStatus(status)
    }
    render() {

        let bigButtonListFix = ""
        let responsiveButtonList = ""
        let updateProfileSpclClass = ""

        if(this.state.modalInfoObjSelected){
            // alert(this.state.modalInfoObjSelected.ref)
            

            if(this.state.modalInfoObjSelected.ref === "web_info"){

                bigButtonListFix = "update_profile_model welcome_area_model"

            }
            if(this.state.modalInfoObjSelected.ref === "profile_edit"){
                updateProfileSpclClass = "update_profile_model"
            }
            if(this.state.modalInfoObjSelected.ref === "fiberglass_steel_entry_doors"){
                bigButtonListFix = "bigButtonListFix"
            }

            if(this.state.modalInfoObjSelected.ref === "keysuccess_progress"){
                bigButtonListFix = "key_success_popup"
            }
            if(this.state.modalInfoObjSelected.ref === "keysuccess_prize"){
                bigButtonListFix = "key_success_popup"
            }

            if(this.state.modalInfoObjSelected.ref === "keysuccess_rules"){
                bigButtonListFix = "key_success_popup"
            }

            if(this.state.modalInfoObjSelected.ref === "rotation_keysuccess"){
                bigButtonListFix = "key_success_rotate_div"
            }
        }


        if(this.state.navigationButtonsShow) {

            responsiveButtonList = "buttons_popup"
        }

        //button_inline
        return(

            <>
            <div className={`main_popup ${this.state.btn_inline}`} >
                <div id="myModal" className={`modal fade ${updateProfileSpclClass}`}   role="dialog"  >
                    <div className={`modal-dialog ${bigButtonListFix}  ${responsiveButtonList}`}  role="document" >

                        <div className="modal-content">

                            <div className="modal-body p-0">
                                <button type="button" className="close" id="closemodalbtn"  aria-label="Close" onClick={this.handleModalClose}>
                                    <span aria-hidden="true"><img src={close_img} alt="" /></span>
                                </button> 


                                <div id="content_div">
                                    {
                                    this.state.displayDataShow &&    <DisplayData 
                                            videStarted={this.state.videStarted}
                                            videoPlayedSeconds={this.state.videoPlayedSeconds}
                                            videoTotalDuration={this.state.videoTotalDuration}
                                            updateVideoPlayingTime={this.handleupdateVideoPlayingTime}
                                            changeVIdeoStatus={this.handleVideoStatus}
                                            changevideoPlayStatus={this.handleVideoPlayStatus}
                                            device = { this.props.device}
                                            isVideoPaused={this.state.videoPausedStatus}
                                            changeModalPopupDisplayData={(val) => {this.props.changeModalContent(val)}}
                                            modalContentInfo={this.state.modalContentInfo} 
                                            loaderStatus={this.loadingStatus} 
                                            modalInfoObjSelected = {this.state.modalInfoObjSelected}
                                            changeRender360Map = {this.props.changeRender360Map}
                                            />
                                    }
                                
                                    {
                                    this.state.displayDataSelectorShow &&  <DisplayDataSelector 
                                                changevideoPlayStatus={this.handleVideoPlayStatus}
                                                device = { this.props.device}
                                                modalInfoObjSelected = {this.state.modalInfoObjSelected}
                                                modalContentInfo={this.state.selectedContentComponents}
                                                changeDisplayToButtonList={this.changeDisplayToButtonList}
                                                navigationLevel={this.state.navigationLevel} 
                                                selectorArray={this.state.selectorArray} 
                                                setDisplayOnlyView={this.setDisplayOnlyView}
                                                changeModalContent={this.props.changeModalContent}
                                                loaderStatus={this.loadingStatus} 

                                                />
                                    }

                                    {
                                    this.state.navigationButtonsShow &&  <NavigationButtonsList
                                                modalContentInfo={this.state.modalContentInfo}
                                                setDisplayOnlyView={this.setDisplayOnlyView}
                                                buttonListArray={this.state.buttonListArray} 
                                                changeModalContent={this.props.changeModalContent}
                                                />
                                    }
                                </div>

                            </div>
                    
                        </div>

                    </div>
                </div>

                </div>
                <div className="full_screen_div">
                    <img src="images/gallery_main.png" alt="" id="fullscreen-view" className="w-100 full_screen_img" />
                    <div className="full_screen_div_close" onClick={() => {  $(".full_screen_div").hide()   }}>
                    
                    <img src="images/fullscreen_zoom_close.png" />
                    </div>
                </div>
            </>
            

        )
    }
}


export default PopModalComponent